import React, { useEffect, useState } from "react";
import {
  Box,
  Input,
  Table,
  TableContainer,
  IconButton,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  Button
} from "@chakra-ui/react";
import CustomButton from "../../../../elements/customButton";
import Pagination from "../../../../elements/Pagination";
import { ChevronRightIcon } from "@chakra-ui/icons";
import moment from "moment";
import Loader from "../../../../elements/loader";
import { bindActionCreators } from "redux";
import { ActionCreators } from "../../../../../redux/actions";
import { connect, useSelector } from "react-redux";
import NoData from "../../../../elements/NoData";
import * as routesNames from "../../../../../constants/routes";
import { removeItem, setItem } from "../../../../../utilities/authUtils.js";
import { fetchCurrentCollection } from '../../../../../services/adminServices'
  

const Upcoming_Collection = (props) => {
  const adminState = useSelector((state) => state.adminState);
  const [currentPage, setCurrentPage] = useState(0);
  const [filterData, setFilterData] = useState([]);
  const currentCollectionData = adminState?.getCurrentCollection?.data?.data;
  const PER_PAGE = 10;
  const offset = currentPage * PER_PAGE;
  const pageCount = Math.ceil(filterData?.length / PER_PAGE);



  useEffect(() => {
    if (props.tabSelected === "Upcoming") {
      let data = {
        type: 2,
      };
      props?.actions?.getCurrentCollectionAction(data);
    }
     removeItem("ckyc_number")
  }, [props.tabSelected]);

  useEffect(() => {
    setFilterData(adminState?.getCurrentCollection?.data?.data)
  }, [adminState?.getCurrentCollection])
  

  useEffect(() => {
    if (props.tabSelected === "Upcoming") {
    let data = {
      type: 2,
    };
    fetchCurrentCollection(data).then((response)=>{
      let filteredEvents = response?.data?.data?.filter((item) => {
        const disbursedDate = new Date(item?.emi_date);
        const fromDate = props.inputValues?.from_date
          ? new Date(props.inputValues?.from_date)
          : 0; 
          const toDate = props.inputValues?.to_date
          ? new Date(props.inputValues?.to_date)
          : (() => {
              const futureDate = new Date();
              futureDate.setMonth(futureDate.getMonth() + 2); 
              return futureDate;
          })();
        return disbursedDate > fromDate && disbursedDate < toDate;
      });
      setFilterData(filteredEvents);
         
   })
  }
  
  },[props.inputValues]);


  const handleSearch = (e) => {
    const {value} = e.target
       setCurrentPage(0)
       if (value !== '') {
        const result = currentCollectionData.filter((item) => {
          return (item?.loan_number?.toLowerCase().includes(value.toLowerCase()) ||  item?.first_name?.toLowerCase().includes(value.toLowerCase()) || item?.last_name?.toLowerCase().includes(value.toLowerCase())|| item?.middle_name?.toLowerCase().includes(value.toLowerCase()) || (item?.UMRN && item.UMRN.toLowerCase().includes(value.toLowerCase()))|| item?.cp_name?.toLowerCase().includes(value.toLowerCase()))
        })
        setFilterData(result)        
      } else {
        setFilterData(currentCollectionData)
      }
    };

  const handlePageClick = ({ selected: selectedPage }) => {
    setCurrentPage(selectedPage);
  };

  return (
    <>
      {(adminState?.getCurrentCollection?.loading ||
        adminState?.getUserByToken?.loading) && (
        <div>
          <Loader />
        </div>
      )}
      <Box mt={1}>
        <Box className="search_box">
          <Input
            type="text"
            size="md"
            name="search"
            placeholder="Search"
            onChange={handleSearch}
            className="input_box font-poppins"
          />
        </Box>
        <>
          {filterData?.length > 0  ? (
            <Box mt={2} className="custom_table_wrapper custom_table_wrapper2">
              <TableContainer>
                <Table variant="simple">
                  <Thead>
                    <Tr>
                      <Th>S.No.</Th>
                      <Th>Channel Partner Name</Th>
                      <Th>Name</Th>
                      <Th>Amortization</Th>
                      <Th>Loan Details</Th>
                      <Th>Loan Contract</Th>
                      <Th>Loan Disbursed Date</Th>
                      <Th>Loan EMI Date</Th>
                      <Th>Loan Presentation date</Th>
                      <Th>Presented Amount</Th>
                      <Th>Status</Th>
                      <Th></Th>
                    </Tr>
                  </Thead>
                  <Tbody>
                    {filterData
                      ?.slice(offset, offset + PER_PAGE)
                      ?.map((item, index) => {
                        const serialNumber = offset + index + 1;
                        return (
                          <Tr key={index}>
                            <Td>
                              <Text className="font-poppins table_text">
                                {serialNumber}
                              </Text>
                            </Td>
                            <Td>
                              <Text className="font-poppins table_text">
                                {item?.cp_name ? item?.cp_name : "NA"}
                              </Text>
                            </Td>
                            <Td>
                            <Text className="font-poppins table_text">
                                {item?.first_name} {' '} {item?.middle_name} {' '}
                                {item?.last_name }
                              </Text>
                            </Td>
                           
                            <Td>
                              <Text className="font-poppins table_text">
                                {item?.amortization_txnID ? item?.amortization_txnID : "NA"}
                              </Text>
                            </Td>
                            <Td>
                            <Text className="font-poppins  gray_text">
                                {item?.UMRN ? item?.UMRN : "NA"}
                              </Text>
                              <Td>
                              
                              <Text className="font-poppins table_text">
                                {item?.loan_number ? item?.loan_number : "NA"}
                              </Text>
                            </Td>
                            </Td>
                            <Td>
                              <Text className="font-poppins table_text">
                                {item?.loan_contract_number
                                  ? item?.loan_contract_number
                                  : "Not Assigned"}
                              </Text>
                            </Td>
                            <Td>
                              <Text className="font-poppins table_text">
                                {item?.disbursed_date
                                  ? moment(item?.disbursed_date).format(
                                      "DD-MMM-YYYY"
                                    )
                                  : "Not Available"}
                              </Text>
                            </Td>
                            <Td>
                              <Text className="font-poppins table_text">
                                {item?.emi_date
                                  ? moment(item?.emi_date).format("DD-MMM-YYYY")
                                  : "Not Available"}
                              </Text>
                            </Td>
                            <Td>
                              <Text className="font-poppins table_text">
                                {item?.presentation_date
                                  ? moment(item?.presentation_date).format(
                                      "DD-MMM-YYYY"
                                    )
                                  : "Not Available"}
                              </Text>
                            </Td>
                            <Td>
                              <Text className="font-poppins table_text">
                              {item?.enach_amount ? item?.enach_amount: "Not Available"}
                              </Text>
                            </Td>
                            <Td>
                               <Button size="md" className="btn_table_upcoming font-poppins" >
                                         {item?.display_status}
                                </Button>
                                <Td>
                              <Text className="font-poppins red_text">
                                {item?.failure_response ? item?.failure_response : ""}
                              </Text>
                            </Td>
                               {/* </Box> */}

                            </Td>
                            <Td>
                              <Box className="actions_td action_table">
                                <IconButton
                                  onClick={() =>
                                    props.handleVerify(item)
                                  }
                                >
                                  <ChevronRightIcon />
                                </IconButton>
                              </Box>
                            </Td>
                          </Tr>
                        );
                      })}
                  </Tbody>
                </Table>
              </TableContainer>
              <Pagination
                pageCount={pageCount}
                handlePageClick={handlePageClick}
              />
            </Box>
          ) : (
            <NoData title="No Record Found" />
          )}
        </>
      </Box>
    </>
  );
};

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(ActionCreators, dispatch),
});

export default connect(null, mapDispatchToProps)(Upcoming_Collection);
